import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import makeStyles from '@material-ui/core/styles/makeStyles';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import { useTrans } from '../../../services/i18n';

const useStyles = makeStyles((theme) => ({
  iconWrap: {
    display: 'inline-flex',
    marginLeft: 6,
    verticalAlign: 'middle',
    cursor: 'pointer',
    lineHeight: 0,
  },
  icon: {
    width: 16,
    height: 16,
    color: '#888FA9',
  },
  popper: {
    zIndex: theme.zIndex.modal + 1,
  },
  tooltip: {
    backgroundColor: '#fff',
    color: '#2E395D',
    boxShadow: '0 2px 12px rgba(46, 57, 93, 0.16)',
    padding: '12px 16px',
    maxWidth: 320,
    fontSize: '0.8125rem',
    lineHeight: 1.45,
  },
  arrow: {
    color: '#fff',
  },
  title: {
    fontWeight: 700,
    marginBottom: 8,
  },
  roleLine: {
    marginBottom: 6,
    '&:last-child': {
      marginBottom: 0,
    },
  },
}));

function RolePermissionsHint() {
  const { trans } = useTrans();
  const classes = useStyles();

  const title = (
    <div>
      <div className={classes.title}>{trans('role-permissions')}</div>
      <div className={classes.roleLine}>
        <strong>{trans('owner')}</strong>
        {` — ${trans('role-owner-hint')}`}
      </div>
      <div className={classes.roleLine}>
        <strong>{trans('admin')}</strong>
        {` — ${trans('role-admin-hint')}`}
      </div>
      <div className={classes.roleLine}>
        <strong>{trans('user')}</strong>
        {` — ${trans('role-user-hint')}`}
      </div>
    </div>
  );

  return (
    <Tooltip
      title={title}
      arrow
      interactive
      placement="right"
      PopperProps={{ disablePortal: false }}
      classes={{ popper: classes.popper, tooltip: classes.tooltip, arrow: classes.arrow }}
    >
      <span className={classes.iconWrap}>
        <InfoOutlined className={classes.icon} />
      </span>
    </Tooltip>
  );
}

export default RolePermissionsHint;
